var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("授权店铺信息已取消")]),_c('Form',[_c('FormItem',[_c('Col',{attrs:{"span":"6"}},[_c('Button',{attrs:{"type":"primary","long":""},on:{"click":_vm.returnBack}},[_vm._v("返回")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }